import { Box, FlexBox } from "../../../Components/Boxes";
import Icon from "../../../Components/Icons";
import { Text } from "../../../Components/Text";
import { useResponsive } from "../../../Components/Hooks/index";
import { Button, TextBox } from "../../../Components/Input";
import { useEffect, useState } from "react";
import FormDialog from "../../../Components/Modals/FormDialog";
import { AddStaff } from "./Profile/Dialogs/AddStaff";
import useStaffDispathers from "../../../redux/dispatchers/useStaffDispatchers";
import {
  useAllStaffSelector,
  useNewStaffStatusSelector,
  useMoreStaffLeftInPaginationSelector,
  useStaffPaginationNextPage,
} from "../../../redux/selectors/useStaffSelectors";
import * as asyncStates from "../../../redux/constants/asyncStates";
import EmptyState from "../../../Components/NoRecordFound";
import DataTable from "../../../Components/DataTable";
import { peopleColumns, renderPeopleCard } from "../peopleColumns";
import { useFilterTeamsSelector } from "../../../redux/selectors/useTeamSelectors";
import usePermissionsController from "../../../permissions";

export default function Staff() {
  // see whether it's desktop size or not
  const isDesktop = useResponsive({ xs: false, sm: true });

  const { addStaff } = usePermissionsController();

  const {
    getNewStaff,
    clearAllLocalStaff,
    clearAllErrorMessages,
    clearAllSuccessMessages,
  } = useStaffDispathers();

  //selectors
  const newStaff = useAllStaffSelector();
  const newStaffLoader = useNewStaffStatusSelector();
  const moreStaffLeftInPagination = useMoreStaffLeftInPaginationSelector()
  const filteredTeams = useFilterTeamsSelector()
  const nextPage = useStaffPaginationNextPage();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryTimer, setSearchQueryTimer] = useState(null);

  const [open, setOpen] = useState(false);
  function HandleDialog() {
    setOpen(!open);
  }

  const loadMore = () => {
    getNewStaff({
      query: searchQuery,
      startAfter: nextPage,// newStaff[newStaff.length - 1].id,
      teams: filteredTeams?.map(e => e.id),
    });
  }

  const handleQuery = (e) => {
    setSearchQuery(e.target.value);
    if (searchQueryTimer) {
      clearTimeout(searchQueryTimer);
    }

    const timeout = setTimeout(() => {
      getNewStaff({
        query: e.target.value,
        teams: filteredTeams?.map(e => e.id),
      });
    }, 500);
    setSearchQueryTimer(timeout);
  };

  const addButton = (
    <Button
      $onClick={() => {
        HandleDialog();
      }}
    >
      <Icon $icon="Add" $color="white"></Icon>
      <Text $color={"white"}>Add</Text>
    </Button>
  );

  useEffect(() => {
    clearAllLocalStaff();
    clearAllErrorMessages();
    clearAllSuccessMessages();
    getNewStaff({
      query: searchQuery,
      teams: filteredTeams?.map(e => e.id),
    });
  }, [filteredTeams]);

  return (
    <>
      <FlexBox
        $justifyContent="space-between"
        $width="98%"
        $marginTop={2}
        $marginBottom={2}
      >
        {/* Search box */}
        <TextBox
          $width="40%"
          $hint={"Search ..."}
          $type={"text"}
          $name={"search"}
          $value={searchQuery}
          $onChange={handleQuery}
          $borderRadius="8px"
          $border="1px solid black"
          $trailing={
            <Icon $icon="Search" $size="20px" />
          }
        />

        {addStaff && addButton}
      </FlexBox>

      <Box $width="100%">
        <DataTable
          ariaLabel="Staff"
          columns={peopleColumns("staff")}
          rows={newStaff}
          getRowKey={(value, index) => value.id ?? index}
          getRowHref={(value) => `/team/staff/${value.id}`}
          renderCard={renderPeopleCard("staff")}
          loading={newStaffLoader === asyncStates.PENDING}
          empty={
            newStaffLoader === asyncStates.SUCCESS && newStaff.length < 1 ? (
              <EmptyState action={addStaff ? addButton : null} />
            ) : null
          }
        />
      </Box>

      {moreStaffLeftInPagination && <FlexBox $marginTop="6">
        <Button $onClick={() => {
          loadMore()
        }} >Load More</Button>
      </FlexBox>}

      <FormDialog
        $open={open}
        $handleDialog={HandleDialog}
        $title={"Add Staff Member"}
        $maxWidth="sm"
        $fullWidth
        $fullScreen={!isDesktop}
      >
        <AddStaff $handleDialog={HandleDialog} />
      </FormDialog>
    </>
  );
}
